import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { Button, Row, Col, Image } from "react-bootstrap";
import "./Home.scss";
import Title from "../../components/Title/Title";
import Portfolio from "../../components/Portfolio/Portfolio";
import ContactForm from "../../components/ContactForm/ContactForm";
import AOS from "aos";
import "aos/dist/aos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCheck,
  faCertificate,
  faClipboardCheck,
  faMobileScreenButton,
  faBrain,
  faGaugeHigh,
  faLocationDot,
  faPhone,
  faOilWell
} from "@fortawesome/free-solid-svg-icons";
import { faCircleCheck, faMessage, faEnvelope } from "@fortawesome/free-regular-svg-icons";

import IconBox from "../../components/IconBox/IconBox";
import GoogleCalendarPopup, { GOOGLE_CALENDAR_GENERAL_URL } from "../../components/GoogleCalendarPopup/GoogleCalendarPopup";

export default function Home(props) {
  let { id } = useParams();
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const consultationRef = useRef(null);
  const portfolioRef = useRef(null);
  const contactUsRef = useRef(null);

  const aboutRefIsVisible = useIsVisible(aboutRef);
  const servicesRefIsVisible = useIsVisible(servicesRef);
  const consultationRefIsVisible = useIsVisible(consultationRef);
  const contactUsRefIsVisible = useIsVisible(contactUsRef);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    if (id === "services" && servicesRef.current) servicesRef.current.scrollIntoView({ behavior: "smooth" });
    if (id === "contact" && contactUsRef.current) contactUsRef.current.scrollIntoView({ behavior: "smooth" });
    if (id === "about" && aboutRef.current) aboutRef.current.scrollIntoView({ behavior: "smooth" });
    if (id === "consultation" && consultationRef.current) consultationRef.current.scrollIntoView({ behavior: "smooth" });
    if (id === "portfolio" && portfolioRef.current) portfolioRef.current.scrollIntoView({ behavior: "smooth" });
  }, [id]);

  useEffect(() => {
    if (props.onNavUpdate) {
      if (aboutRefIsVisible) props.onNavUpdate("/home/about");
      else if (servicesRefIsVisible) props.onNavUpdate("/home/services");
      else if (consultationRefIsVisible) props.onNavUpdate("/home/consultation");
      else if (contactUsRefIsVisible) props.onNavUpdate("/home/contact");
      else props.onNavUpdate("/");
    }
  }, [props, aboutRefIsVisible, servicesRefIsVisible, consultationRefIsVisible, contactUsRefIsVisible]);

  return (
    <div id={props.main_id} className="home-container">
      {/* About Section */}
      <div ref={aboutRef} className="section-bg about section py-5" id="about">
        <div className="container">
          <Row className="py-5">
            <Col xs={12} data-aos="fade-up" data-aos-duration="500">
              <Title regular_text="About" highlighted_text="Us" />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={4} className="d-flex text-center mb-4" data-aos="fade-up" data-aos-duration="500">
              <IconBox
                icon={<FontAwesomeIcon icon={faUserCheck} />}
                title="Experienced"
                description="Our team memebers have decades of experience in the technology industry"
              />
            </Col>

            <Col xs={12} lg={4} className="d-flex text-center mb-4" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
              <IconBox
                icon={<FontAwesomeIcon icon={faCertificate} />}
                title="Professional"
                description="You'll always receive the best recommandations and solutions to your problems"
              />
            </Col>

            <Col xs={12} lg={4} className="d-flex text-center mb-4" data-aos="fade-up" data-aos-duration="500" data-aos-delay="400">
              <IconBox
                icon={<FontAwesomeIcon icon={faClipboardCheck} />}
                title="Quality"
                description="We guarrantee that our solutions will 100% meet your business needs"
              />
            </Col>
          </Row>
        </div>
      </div>

      {/* About Company Section */}
      <div className="section about-2 p-0 bg-dark" id="aboutCompany">
        <div className="container-fluid p-0">
          <Row className="g-0 align-items-center">
            <Col xs={12} lg={6}>
              <Image fluid src={require("../../assets/about.jpg")} alt="About Woodlands Digital Technologies" />
            </Col>
            <Col xs={12} lg={6} data-aos="fade-up" data-aos-duration="500">
              <div className="content-block">
                <h2>We’re A Technology and Innovation Agency</h2>
                <p>
                  Woodlands Digital Technologies was founded in The Woodlands - Texas, to help business modernize and
                  adopt proven digital technologies while retaining their existing values and way of doing business.
                  We believe in incremental technology adoption such that the business owners and their customers stay
                  comfortable and remain always in control.
                </p>
                <Button
                  id="link_about_leadership"
                  as={Link}
                  to="/about-founder"
                  size="lg"
                  variant="outline-primary"
                  className="mt-5"
                >
                  Leadership & Values
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Services Section */}
      <div ref={servicesRef} id="services" className="section-bg section">
        <div className="container py-5">
          <Row className="py-5">
            <Col xs={12} data-aos="fade-up" data-aos-duration="500">
              <Title regular_text="Our" highlighted_text="Services" />
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs={12} md={6} lg={3} className="d-flex text-center mb-4" data-aos="fade-up" data-aos-duration="500">
              <IconBox
                main_id="link_about_mobile_apps"
                icon={<FontAwesomeIcon icon={faMobileScreenButton} />}
                title="Apps Development"
                description="Accelerate your growth with cutting-edge web and mobile app solutions built to scale. From first product to enterprise scale, we turn bold ideas into seamless digital experiences."
                cta_label="Learn More"
                cta_link="/about-mobile-apps"
              />
            </Col>
            <Col xs={12} md={6} lg={3} className="d-flex text-center mb-4" data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">
              <IconBox
                main_id="link_about_ai"
                icon={<FontAwesomeIcon icon={faGaugeHigh} />}
                title="Custom Business Solution & AI"
                description="Transform the way your business works with software built specifically for your needs—automating tasks, streamlining workflows, and uncovering data insights."
                cta_label="Learn More"
                cta_link="/about-ai"
              />
            </Col>
            <Col xs={12} md={6} lg={3} className="d-flex text-center mb-4" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
              <IconBox
                main_id="link_about_oil_and_gas"
                icon={<FontAwesomeIcon icon={faOilWell} />}
                title="Oil & Gas Solutions"
                description="Partnering with in-house energy SMEs to build secure AI assistants, upstream HSE benchmarking, terminal logistics, and air-gapped cloud software."
                cta_label="Learn More"
                cta_link="/oil-and-gas"
              />
            </Col>
            <Col xs={12} md={6} lg={3} className="d-flex text-center mb-4" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">
              <IconBox
                main_id="link_advisory"
                icon={<FontAwesomeIcon icon={faBrain} />}
                title="Advisory"
                description="Empower your business with strategic technology, software, and AI insights that drive measurable impact, streamline operations, and boost efficiency."
                cta_label="Contact Us"
                cta_link="/home/contact"
              />
            </Col>
          </Row>
        </div>
      </div>

      {/* Free Consultation Section */}
      <div ref={consultationRef} className="call-to-action section-sm bg-1 overly" id="consultation">
        <div className="container" data-aos="fade-up" data-aos-duration="500">
          <Row className="justify-content-md-center py-5">
            <Col md={8} lg={6}>
              <h2>Free Consultation</h2>
              <p>
                To get to know you and address any questions that you might have we offer a free consultation.
                The consultation can be a video call, phone call or in person if you are located in the Houston metro area.
                We will try to cover the following topics:
              </p>
              <ul className="list-unstyled consultation-list">
                <li><FontAwesomeIcon icon={faCircleCheck} className="me-2" /> Understand your business</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="me-2" /> Understand your needs</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="me-2" /> Brainstorm possible solutions to your needs</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="me-2" /> Get a high level approximate quote</li>
              </ul>
              <GoogleCalendarPopup
                id="link_schedule"
                url={GOOGLE_CALENDAR_GENERAL_URL}
                label="Book an appointment"
                className="mt-3 btn-main"
              />
            </Col>
          </Row>
        </div>
      </div>

      {/* Recent Customers / Portfolio Section */}
      <div ref={portfolioRef}>
        <Portfolio />
      </div>

      {/* Contact Us Section */}
      <div ref={contactUsRef} id="contact" className="contact-us section-bg">
        <div className="container">
          <Row className="py-5">
            <Col xs={12} data-aos="fade-up" data-aos-duration="500">
              <Title regular_text="Get In" highlighted_text="Touch" />
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="contact-info" data-aos="fade-up" data-aos-duration="500">
              <h3>Contact Details</h3>
              <div className="contact-details">
                <div className="d-flex flex-row align-items-start mt-3">
                  <FontAwesomeIcon className="mt-1" icon={faLocationDot} />
                  <div className="ms-3">7 Columnberry Ct.,<br />The Woodlands, TX 77384</div>
                </div>

                <div className="d-flex flex-row align-items-start mt-3">
                  <FontAwesomeIcon className="mt-1" icon={faPhone} />
                  <div className="ms-3">Phone: ‪(346) 800-2244‬</div>
                </div>

                <div className="d-flex flex-row align-items-start mt-3">
                  <FontAwesomeIcon className="mt-1" icon={faMessage} />
                  <div className="ms-3">Text: ‪(346) 800-2244‬</div>
                </div>

                <div className="d-flex flex-row align-items-start mt-3">
                  <FontAwesomeIcon className="mt-1" icon={faEnvelope} />
                  <div className="ms-3">Email: contact@wdttx.com</div>
                </div>
              </div>
            </Col>
            <Col lg={6} className="mt-4 mt-lg-0" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
              <ContactForm customer_id="912c7bbe-53e2-49c9-a001-a9b645f91eaf" />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export function useIsVisible(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(([entry]) =>
      setIntersecting(entry.isIntersecting)
    );

    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return isIntersecting;
}
